


















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  DrivewealthAccountManagementType,
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({ components: {} })
export default class InstrumentName extends Vue {
  @Prop({ required: true }) website: string;
  @Prop({ required: true }) companyName: string;
  @Prop({ required: true }) symbol: string;
  @Prop({ required: true }) imageUrl: string;
  @Prop({ required: false }) accountId?: number;
  @Prop({ required: false }) displaySymbol: string;

  drivewealthStore = useDrivewealthStore();

  openInstrumentUrl (): void {
    this.drivewealthStore.openInstrumentDetailFundResearchUrl({ stockSymbol: this.symbol, fallbackUrl: this.website });
  }
}
